import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/core/navbar/navbar.component';
import { LoginComponent } from './components/core/login/login.component';
import { Error404Component } from './components/core/error404/error404.component';
import { PlaceholderComponent } from './components/core/placeholder/placeholder.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpAuthInterceptor } from './interceptors/http-auth.interceptor';
import { AuthService } from './services/auth.service';
import { HandspraySiteComponent } from './components/handspray/handspray-site/handspray-site.component';
import { HandsprayVisitComponent } from './components/handspray/handspray-site/handspray-visit/handspray-visit.component';
import { HandsprayVisitListComponent } from './components/handspray/handspray-site/handspray-visit-list/handspray-visit-list.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ConfirmDialogComponent } from './components/core/confirm-dialog/confirm-dialog.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccountComponent } from './components/core/account/account.component';
import { ImageModalComponent } from './components/core/image-modal/image-modal.component';
import { VisitGpsModalComponent } from './components/handspray/handspray-site/handspray-visit/visit-gps-modal/visit-gps-modal.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { WeedfreeFormMmtComponent } from './components/weedfree/forms/weedfree-form-mmt/weedfree-form-mmt.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { HandsprayMapComponent } from './components/handspray/handspray-map/handspray-map.component';
import { MmtVisitsComponent } from './components/mmt/mmt-visits/mmt-visits.component';
import { MmtVisitComponent } from './components/mmt/mmt-visit/mmt-visit.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { MmtMapComponent } from './components/mmt/mmt-map/mmt-map.component';
import { ClientDocumentsComponent } from './components/client-documents/client-documents.component';
import { WeedfreeFormMmtCovidComponent } from './components/weedfree/forms/weedfree-form-mmt-covid/weedfree-form-mmt-covid.component';
import { MmtCovidVisitComponent } from './components/mmt/mmt-covid-visit/mmt-covid-visit.component';
import { WeedfreeClientDocumentsComponent } from './components/weedfree/weedfree-client-documents/weedfree-client-documents.component';
import { ClientDocumentListComponent } from './components/weedfree/weedfree-client-documents/client-document-list/client-document-list.component';
import { ClientDocumentUploadComponent } from './components/weedfree/weedfree-client-documents/client-document-upload/client-document-upload.component';
import { PasswordPolicyComponent } from './components/core/account/password-policy/password-policy.component';
import { WeedfreeFormLegionellaComponent } from './components/weedfree/forms/weedfree-form-legionella/weedfree-form-legionella.component';
import { LegionellaVisitsComponent } from './components/legionella/legionella-visits/legionella-visits.component';
import { LegionellaVisitComponent } from './components/legionella/legionella-visit/legionella-visit.component';

@NgModule({
    declarations: [
        AppComponent,
        NavbarComponent,
        LoginComponent,
        Error404Component,
        PlaceholderComponent,
        HandsprayMapComponent,
        HandspraySiteComponent,
        HandsprayVisitListComponent,
        HandsprayVisitComponent,
        ConfirmDialogComponent,
        AccountComponent,
        ImageModalComponent,
        VisitGpsModalComponent,
        WeedfreeFormMmtComponent,
        MmtVisitsComponent,
        MmtVisitComponent,
        MmtMapComponent,
        ClientDocumentsComponent,
        WeedfreeFormMmtCovidComponent,
        MmtCovidVisitComponent,
        WeedfreeClientDocumentsComponent,
        ClientDocumentListComponent,
        ClientDocumentUploadComponent,
        PasswordPolicyComponent,
        WeedfreeFormLegionellaComponent,
        LegionellaVisitsComponent,
        LegionellaVisitComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        GoogleMapsModule,
        CarouselModule.forRoot(),
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        ProgressbarModule.forRoot()
    ],
    providers: [
        AuthService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
